import bdReq from '../../network/bdReq';
import bdAuth from '../../network/bdAuth';

import {
  FETCH_DEVICE_REQUEST,
  FETCH_DEVICE_SUCCESS,
  FETCH_DEVICE_FAILURE,
  DELETE_DEVICE_REQUEST,
  DELETE_DEVICE_SUCCESS,
  DELETE_DEVICE_FAILURE,
} from '../constants/deviceConstants';

const fetchDeviceRequest = () => ({ type: FETCH_DEVICE_REQUEST });
const fetchDeviceSuccess = (payload) => ({ type: FETCH_DEVICE_SUCCESS, payload });
const fetchDeviceFailure = (errors) => ({ type: FETCH_DEVICE_FAILURE, errors });

export const fetchDevice = (deviceId) => async (dispatch) => {
  dispatch(fetchDeviceRequest());
  try {
    const response = await bdReq.get(`/v2/devices/${deviceId}/status`);
    if (response.status === 200 && response.success) {
      return dispatch(fetchDeviceSuccess(response.body));
    }
    if (response.status === 400) {
      return dispatch(fetchDeviceFailure('Error'));
    }
    return dispatch(fetchDeviceFailure(response.body.message));
  } catch (e) {
    return dispatch(fetchDeviceFailure(e));
  }
};

const deleteDeviceRequest = () => ({ type: DELETE_DEVICE_REQUEST });
const deleteDeviceSuccess = (payload) => ({ type: DELETE_DEVICE_SUCCESS, payload });
const deleteDeviceFailure = (errors) => ({ type: DELETE_DEVICE_FAILURE, errors });

export const deleteDevice = (deviceId) => async (dispatch) => {
  dispatch(deleteDeviceRequest());
  try {
    const tokens = bdAuth.getToken();
    // const response = await bdReq.delete(`/users/${tokens.user}/devices/${deviceId}`);
    const response = await bdReq.delete(`/v2/devices/${deviceId}`);
    if (response.status === 200 && response.success) {
      return dispatch(deleteDeviceSuccess(response.body));
    }
    if (response.status === 404) {
      return dispatch(deleteDeviceFailure('Error'));
    }
    return dispatch(deleteDeviceFailure(response.body.message));
  } catch (e) {
    return dispatch(deleteDeviceFailure(e));
  }
};

export const updateDevice = (deviceId, updateVal, value) => async () => {
  try {
    const tokens = bdAuth.getToken();
    let body;
    if (updateVal === 'mute') {
      body = {
        mute: value,
      };
    } else if (updateVal === 'qr') {
      body = {
        qr: value,
      };
    } else if (updateVal === 'details') {
      body = {
        details: value,
      };
    } else if (updateVal === 'highQuality') {
      body = {
        highQuality: value,
      };
    } else if (updateVal === 'logo') {
      body = {
        logo: value,
      };
    } else if (updateVal === 'orientation') {
      body = {
        orientation: value,
      };
    } else if (updateVal === 'content') {
      body = {
        matchContent: value,
      };
    } else if (updateVal === "reboot") {
      body = {
        reboot: value,
      };
    } else {
      body = {
        type: 'SCAP',
        interval: value,
      };
    } 
    // const response = await bdReq.patch(`/users/${tokens.user}/devices/${deviceId}`, body);
    const response = await bdReq.patch(`/v2/devices/${deviceId}`, body);
    // console.log("update",response)
    if (response.status === 200 && response.success) {
      return response;
    }
    if (response.status === 404) {
      return 'Error';
    }
    return 'Error';
  } catch (e) {
    return 'Error';
  }
};
